import { render, staticRenderFns } from "./PageTest.vue?vue&type=template&id=69e8ed6c&scoped=true&"
import script from "./PageTest.vue?vue&type=script&lang=js&"
export * from "./PageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e8ed6c",
  null
  
)

export default component.exports